var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.mainData),function(item){return _c('data-item',{key:item.label,attrs:{"data":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }